var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "prefilter-config" }, [
    _c("div", { staticClass: "prefilter-header" }, [
      _c(
        "div",
        { staticClass: "prefilter-toggle" },
        [
          _c("a-switch", {
            on: { change: _vm.onEnabledChange },
            model: {
              value: _vm.localFilters.enabled,
              callback: function ($$v) {
                _vm.$set(_vm.localFilters, "enabled", $$v)
              },
              expression: "localFilters.enabled",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "toggle-label" }, [
            _vm._v(_vm._s(_vm.$t("automation.enablePreFilters"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.localFilters.enabled
        ? _c("div", { staticClass: "prefilter-description" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("automation.preFilterDescription")) +
                "\n        "
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.localFilters.enabled
      ? _c(
          "div",
          { staticClass: "prefilter-body" },
          [
            _vm._l(_vm.localFilters.groups, function (group, groupIndex) {
              return _c(
                "div",
                {
                  key: group.id || "group-" + groupIndex,
                  staticClass: "filter-group-container",
                },
                [
                  _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _vm.localFilters.groups.length > 1
                        ? _c(
                            "div",
                            { staticClass: "group-header" },
                            [
                              _c("span", { staticClass: "group-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("auto.preFilterConfigGrup"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "text",
                                    icon: "delete",
                                    size: "small",
                                    danger: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeGroup(groupIndex)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("auto.preFilterConfigGrubuSil")
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(group.filters, function (filter, filterIndex) {
                        return _c(
                          "div",
                          {
                            key: filter.id || "filter-" + filterIndex,
                            staticClass: "filter-row",
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "filter-text" },
                              [
                                filterIndex === 0
                                  ? _c("span", { staticClass: "prefix" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("auto.preFilterConfigEEr")
                                        )
                                      ),
                                    ])
                                  : _c("InlineSelectOperator", {
                                      staticClass: "prefix-operator",
                                      attrs: {
                                        options: [
                                          { label: "ve", value: "and" },
                                          { label: "veya", value: "or" },
                                        ],
                                      },
                                      model: {
                                        value: group.operator,
                                        callback: function ($$v) {
                                          _vm.$set(group, "operator", $$v)
                                        },
                                        expression: "group.operator",
                                      },
                                    }),
                                _vm._v(" "),
                                _c("InlineSelect", {
                                  attrs: {
                                    options: _vm.getAvailableAttributes(),
                                    placeholder: "alan seçin",
                                    searchable: true,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onAttributeChange(filter)
                                    },
                                  },
                                  model: {
                                    value: filter.attribute,
                                    callback: function ($$v) {
                                      _vm.$set(filter, "attribute", $$v)
                                    },
                                    expression: "filter.attribute",
                                  },
                                }),
                                _vm._v(" "),
                                filter.attribute
                                  ? _c("InlineSelectOperator", {
                                      attrs: {
                                        options:
                                          _vm.getOperatorsForFilter(filter),
                                        placeholder: "operatör",
                                      },
                                      model: {
                                        value: filter.rule,
                                        callback: function ($$v) {
                                          _vm.$set(filter, "rule", $$v)
                                        },
                                        expression: "filter.rule",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                filter.attribute &&
                                !["empty", "non_empty", "not_empty"].includes(
                                  filter.rule
                                )
                                  ? [
                                      _vm.hasOptions(filter.attribute) &&
                                      !_vm.isMultiSelect(filter)
                                        ? _c("InlineSelectValue", {
                                            attrs: {
                                              options: _vm.getOptions(
                                                filter.attribute
                                              ),
                                              placeholder: "değer seçin",
                                              searchable: true,
                                            },
                                            model: {
                                              value: filter.value,
                                              callback: function ($$v) {
                                                _vm.$set(filter, "value", $$v)
                                              },
                                              expression: "filter.value",
                                            },
                                          })
                                        : _vm.isMultiSelect(filter)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "multi-value-wrapper",
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticClass:
                                                    "multi-select-inline",
                                                  attrs: {
                                                    mode: "multiple",
                                                    placeholder: "seçin",
                                                  },
                                                  model: {
                                                    value: filter.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        filter,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "filter.value",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.getOptions(
                                                    filter.attribute
                                                  ),
                                                  function (opt) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: opt.value,
                                                        attrs: {
                                                          value: opt.value,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(opt.label) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm.getAttributeType(
                                            filter.attribute
                                          ) === "boolean"
                                        ? _c("InlineSelectValue", {
                                            attrs: {
                                              options: [
                                                { label: "Evet", value: true },
                                                {
                                                  label: "Hayır",
                                                  value: false,
                                                },
                                              ],
                                              placeholder: "seçin",
                                            },
                                            model: {
                                              value: filter.value,
                                              callback: function ($$v) {
                                                _vm.$set(filter, "value", $$v)
                                              },
                                              expression: "filter.value",
                                            },
                                          })
                                        : _c("InlineInput", {
                                            attrs: {
                                              type:
                                                _vm.getAttributeType(
                                                  filter.attribute
                                                ) === "number"
                                                  ? "number"
                                                  : "text",
                                              placeholder: "değer girin",
                                            },
                                            model: {
                                              value: filter.value,
                                              callback: function ($$v) {
                                                _vm.$set(filter, "value", $$v)
                                              },
                                              expression: "filter.value",
                                            },
                                          }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticClass: "remove-btn",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeFilter(
                                      groupIndex,
                                      filterIndex
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("delete_outline"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "add-condition-btn",
                          on: {
                            click: function ($event) {
                              return _vm.addFilterToGroup(groupIndex)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Koşul ekle")]),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.localFilters.groups.length > 1 &&
                  groupIndex !== _vm.localFilters.groups.length - 1
                    ? _c("div", { staticClass: "group-operator-row" }, [
                        _c("div", { staticClass: "separator-line" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "operator-badge" },
                          [
                            _c(
                              "a-select",
                              {
                                staticClass: "operator-selector",
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.localFilters.operator,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.localFilters, "operator", $$v)
                                  },
                                  expression: "localFilters.operator",
                                },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "and" } },
                                  [_vm._v("VE (AND)")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "or" } },
                                  [_vm._v("VEYA (OR)")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "separator-line" }),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "add-group-btn",
                on: { click: _vm.addFilterGroup },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("add_circle_outline"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("Filtre Grubu Ekle")]),
              ]
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }